import {
  Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, OnChanges, SimpleChange, SimpleChanges, IterableDiffers
} from '@angular/core';
import { LookupDataService, ApiRequestService, UserInfoService } from '../../../BaseFramework/core/http'
import { CommonUtilty, AppMetadataHandler } from 'app'
import { NzMessageService } from 'ng-zorro-antd/message';
import {NzNotificationService} from 'ng-zorro-antd/notification'
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
export interface SearchCriteria {
  key: any,
  keyDescription: any,
  valueInputType: any,
  lookupName: any,
  lookup: any,
  enable: any
  isMandatory: any
}

export interface ValidationOutput {
  missingFields: any,
  missingFieldsArray: any,
  errorType: any
}

export interface searchCriteriaUIDO {
  selectedCriteriaKey: any,
  selectedCriteriaKeyDescription: any,
  selectedValue?: any,
  valueInputType: any,
  lookupName: any,
  lookup: any,
  isMandatory: any
}

@Component({
  selector: 'app-ui-search',
  templateUrl: './ui-search.component.html',
  styleUrls: ['./ui-search.component.scss']
})
export class UISearchComponent implements OnInit {
  constructor(private lookupDataService: LookupDataService,
    private apiRequestService: ApiRequestService,
    private notification: NzNotificationService,
    private translateService: TranslateService,
    private viewContainerRef: ViewContainerRef,
    private userInfoService: UserInfoService,
    private _iterableDiffers: IterableDiffers,
    private commonUtility: CommonUtilty,
    private msg: NzMessageService,
    private appMetadataHandler: AppMetadataHandler
  ) {
    this.iterableDiffer = this._iterableDiffers.find([]).create(null);
  }

  //Declarations
  dataTypeMap = null;
  rows: Array<any> = [];
  lookupList = []
  criteriaType: any
  searchHasData: boolean = false;
  searchTerm: string = '';
  iterableDiffer
  MISSINGMANDATORYSEARCHCRITERIAS = "MISSINGMANDATORYSEARCHCRITERIAS"
  NOPARAMETERSELECTED = "NOPARAMETERSELECTED"
  INPUTVALUEMANDATORYKEY = 'Input Value for Mandatory Search Criteria'
  INPURVALUEMANDATORY = null
  MISSINGSEARCHFIELDSISAREKEY = "Mandatory criteria for search is/are"
  MISSINGSEARCHFIELDSISARE = null
  searchObservable
  searchCriteriaUIDO = {
    selectedCriteriaKey: null,
    selectedCriteriaKeyDescription: null,
    selectedValue: null,
    valueInputType: null,
    lookupName: null,
    lookup: null,
    isMandatory: null
  }

  //Life Hooks
  ngOnInit() {
    if (!environment.production) {
      // console.log(this.getParentComponentName())
    }
    if (this.rows.length === 0) {
      this.addRow()
    }
  }
  /**
   * ComponentSpecific Inputs, Outputs and Functions
   * 
   *  
   */
  @Output() componentOutput = new EventEmitter<any>();
  @Output() criteriaOutput = new EventEmitter<any>();
  @Output() currentRowList = new EventEmitter<any>();

  @Input() searchURL: string
  @Input() dropdownType: string
  @Input() inboxViewName: string
  @Input() searchables: any

  // @Input() SearchCriteria: Array<SearchCriteria> = [];
  private _type: any;
  @Input() set type(value: any) {
    if (value !== null)
      this._type = value
  }

  get type(): any {
    return this._type;
  }

  private _searchCriteria: any;
  @Input() set SearchCriteria(value: any) {
    if (value !== null) {
      this._searchCriteria = value;
      this.populateAllLookup(this._searchCriteria);
      this.addMandatoryRows(this._searchCriteria)
    }
    else
      this._searchCriteria = this.searchCriteriaUIDO
  }
  get SearchCriteria(): any {
    return this._searchCriteria;
  }
  @Input() itemsPerPage: any
  @Input() currentPage: any
  @Input() extraExternalParams: any = []
  @Input() mandatorySearchAttributes: Array<any>
  EmitComponentOutput(data) {
    this.componentOutput.emit(data)
  }
  EmitSelectedCriteria(data) {
    this.currentRowList.emit(this.rows);
    this.criteriaOutput.emit(data);
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
      
    } catch (error) {
      
    }
  }
  getParentComponentName(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
      
    } catch (error) {
      
    }
  }

  //Server Interactions
  populateAllLookup(criteriaArray) {
    if (criteriaArray && typeof criteriaArray === typeof []) {
      criteriaArray.forEach(criteria => {
        if (criteria.lookupName != null)
          this.lookupDataService.getLookup(criteria.lookupName).subscribe(resp => {
            criteria.lookup = resp
            this.setLookupDataToUI(criteria.key, resp);
          })
      })
    }
    else
      throw "UI-Search has been used without 'SearchCriteria' in " + this.getParentComponentName();
  }

  ngDoCheck() {
    let changes = this.iterableDiffer.diff(this.SearchCriteria);
    if (changes) {
      this.populateAllLookup(this.SearchCriteria);
      this.addMandatoryRows(this.SearchCriteria)
    }
  }

  searchAndEmitResultLoading = false
  searchAndEmitResult() {
    this.searchAndEmitResultLoading = true
    var validationOutput: ValidationOutput = this.validateSearchCriteria()
    if (validationOutput.missingFieldsArray.length === 0 && validationOutput['errorType'] && validationOutput.errorType.length === 0) {
      var payload = this.convertToSearchRequestPayload()

      if (this.searchObservable != null)
        this.searchObservable.unsubscribe();
      this.searchObservable = this.apiRequestService.postCallWithAPIMapper(this.searchURL, payload).subscribe(data => {
        this.searchAndEmitResultLoading = false
        if (data && Object.entries(data).length > 0) {
          this.EmitComponentOutput(data)
        }
        else {
          this.msg.error("SERVER ERROR - Unable to fetch Search Result")
        }
      });
    }
    else {
      this.searchAndEmitResultLoading = false
    }


    validationOutput.errorType.forEach(error => {
      if (error === this.MISSINGMANDATORYSEARCHCRITERIAS) {
        this.notification.error(this.INPURVALUEMANDATORY === null ? this.INPUTVALUEMANDATORYKEY : this.INPURVALUEMANDATORY,
          this.MISSINGSEARCHFIELDSISARE === null ? this.MISSINGSEARCHFIELDSISAREKEY : this.MISSINGSEARCHFIELDSISARE + ' - ' + validationOutput.missingFields)
      }
      else if (error === this.NOPARAMETERSELECTED) {
        this.msg.error('There is no parameter selected with value');
      }
      this.searchAndEmitResultLoading = false;
    });

  }

    // Local Data Manipulations
    setCaptureDataType(param) {
      let criteriaMetaData = this.getCriteriaObject(param)
      this.rows.forEach((row,index) => {
        if (row.selectedCriteriaKey === param && criteriaMetaData) {
          row.valueInputType = criteriaMetaData.valueInputType
          row.lookupName = criteriaMetaData.lookupName
          row.lookup = criteriaMetaData.lookup
          row.selectedCriteriaKeyDescription = criteriaMetaData.keyDescription
          row.isMandatory = criteriaMetaData.isMandatory
          if(row.lookup.length == 1 && row.valueInputType == "LOOKUP"){
            this.rows[index].selectedValue = row.lookup[0].lookupKey;
          }
          if(row.lookup.length == 1 && row.valueInputType == "COMBOMULTISELECTCSV"){
            let selectedValue = []
            selectedValue.push(row.lookup[0].lookupKey)
            this.rows[index].selectedValue = selectedValue;
          }
        }
      })
    }

  setLookupDataToUI(key, lookupdata) {
    this.rows.forEach(row => {
      if (row.selectedCriteriaKey === key) {
        row.lookup = lookupdata
      }
    })
  }

  nullifySelectedValue(index) {
    this.rows[index].selectedValue = null
  }

  filterSearchCriteria(rows) {
    let searchCriteria = []
    if (this.commonUtility.isArrayIterable(rows) && Array.isArray(searchCriteria)) {
      rows.forEach((criteriaRow, index) => {
        searchCriteria = this.SearchCriteria.filter(sc => sc.key != criteriaRow.selectedCriteriaKey)
      });
    }
    return searchCriteria
  }

  isSearchCriteriaAlreadySelected(key) {
    if (key) {
      let resultSet = this.rows.filter(criteriaRow => criteriaRow.selectedCriteriaKey == key)
      return resultSet.length > 0
    }
    else
      return false
  }

  convertToSearchRequestPayload() {
    let payload = {}
    let externalParams = this.extraExternalParams
    payload["page"] = this.currentPage || 0
    payload["size"] = this.itemsPerPage || 10
    payload["searchCriteriaList"] = []

    for (let row of this.rows) {
      //Condition for Row
      if(row.valueInputType === 'DATE'){
        let selectedDateValue =  this.commonUtility.UIDOtoServerDODate(row.selectedValue)
        row.selectedValue = this.commonUtility.deepCopy(selectedDateValue);
      }

      var criteriaItem = {}
      let externalParam = externalParams.find(e => e.paramName == row.selectedCriteriaKey) || {}
      if (externalParam.paramName) {
        externalParams = externalParams.filter(e => e.paramName == externalParam.paramName)
      }
      if (this.dropdownType == 'single') {
        let userId = null
        userId = this.userInfoService.getUserId();

        criteriaItem["paramName"] = 'searchkey'
        criteriaItem["paramValue"] = row.selectedCriteriaKey
        payload["searchCriteriaList"].push(criteriaItem)

        criteriaItem = {}
        criteriaItem["paramName"] = 'searchValue'
        criteriaItem["paramValue"] = row.selectedValue
        payload["searchCriteriaList"].push(criteriaItem)

        criteriaItem = {}
        criteriaItem["paramName"] = 'userId'
        criteriaItem["paramValue"] = userId
        payload["searchCriteriaList"].push(criteriaItem)

        criteriaItem = {}
        criteriaItem["paramName"] = 'viewName'
        criteriaItem["paramValue"] = this.inboxViewName
        payload["searchCriteriaList"].push(criteriaItem)
        criteriaItem = {}
      }
      else {
        criteriaItem["paramName"] = row.selectedCriteriaKey
        criteriaItem["paramValue"] = externalParams.paramValue || row.selectedValue
        payload["searchCriteriaList"].push(criteriaItem)
      }
      if (this.type === 'BULK') {

        let userId = null
        userId = this.userInfoService.getUserId();
        criteriaItem = {}
        criteriaItem["paramName"] = 'userId'
        criteriaItem["paramValue"] = userId
        payload["searchCriteriaList"].push(criteriaItem)
      }
    }

    if (this.commonUtility.isArrayIterable(externalParams) && Array.isArray(payload["searchCriteriaList"]))
      payload["searchCriteriaList"].push(...externalParams)
    return payload
  }

  //Utility Functions

  dropDownOrTextBox(param) {
    let searchObj = this.getCriteriaObject(param)
    return searchObj.valueInputType
  }

  public checkWhetherExternalCriteria(selectedCriteriaKey): any {
    return this.extraExternalParams.find(e => e.paramName == selectedCriteriaKey);
  }

  getCriteriaObject(param) {
    return this.SearchCriteria.find(criteria => criteria.key === param)
  }

  resetResult() {
    this.searchAndEmitResultLoading = false;
    this.rows.forEach(row => {
      row.selectedCriteriaKey = null;
      row.selectedValue = null;
    })

    if (this.commonUtility.isArrayIterable(this.rows))
      this.rows = this.rows.slice(0, 1)
    
    this.currentRowList.emit(this.rows);
    this.EmitComponentOutput({ 'reset': true });
  }

  validateSearchCriteria(): ValidationOutput {
    let missingFields = ""
    let missingFieldsArray = []
    let lengthOfParamenter = this.rows.length || 0
    let lengthOfNullValues = 0
    let errorTypes = []

    this.rows.forEach(row => {
      let count = 0
      if (row.isMandatory && row.selectedValue === null) {
        if (count === 0) {
          errorTypes.push(this.MISSINGMANDATORYSEARCHCRITERIAS)
          count += 1
        }
        missingFields += row.selectedCriteriaKeyDescription + " | "
        missingFieldsArray.push(row)
        console.log(row)
      }

      let externalParam = this.checkWhetherExternalCriteria(row.selectedCriteriaKey)

      //if present in external params, default the value
      if (externalParam)
        row.selectedValue = externalParam.paramValue


      if (!row.selectedValue) {
        lengthOfNullValues += 1
      }
    })

    if (lengthOfParamenter === lengthOfNullValues) {
      errorTypes.push(this.NOPARAMETERSELECTED)
    }

    return {
      missingFields: missingFields,
      missingFieldsArray: missingFieldsArray,
      errorType: errorTypes
    }
  }

  //UI Triggers
  addRow() {
    var objDummy = JSON.parse(JSON.stringify(this.searchCriteriaUIDO));
    this.rows.push(objDummy);
  }

  addMandatoryRows(criteriaArray) {
    if (criteriaArray && typeof criteriaArray === typeof []) {
      var me = this
      criteriaArray.forEach(o => {
        if (o.isMandatory) {
          let objDummy: searchCriteriaUIDO = {
            isMandatory: o.isMandatory,
            lookupName: o.lookupName,
            lookup: o.lookup,
            selectedCriteriaKey: o.key,
            selectedCriteriaKeyDescription: o.keyDescription,
            valueInputType: o.valueInputType,
            selectedValue: null
          }
          //me.rows.push(objDummy);
          me.rows = this.commonUtility.uniquePushInArray(me.rows,objDummy,'selectedCriteriaKey');
        }
      })
    }
    else
      throw "UI-Search has been used without 'SearchCriteria' in " + this.getParentComponentName();
  }

  removeRow(i) {
    this.rows.splice(i, 1);
    if (0 == this.rows.length && !this.searchTerm) this.searchHasData = false;
    this.currentRowList.emit(this.rows);
  }

  //Listners
  criteriaSelected(param, index) {
    this.setCaptureDataType(param)
    this.nullifySelectedValue(index)
  }

  modelChanged(e) {
    var searchCriteriaRow = this.getFirstRowOfSearch(this.rows)
    if (this.rows.length === 1 && searchCriteriaRow &&
      searchCriteriaRow.selectedValue.trim() != null &&
      searchCriteriaRow.selectedValue.trim() != "") {
      this.searchHasData = true;
    }
    else if (this.rows.length > 1) {
      this.searchHasData = true;
    }
    else if (0 == this.rows.length)
      this.searchHasData = false;
  }

  getFirstRowOfSearch(criteriaArray) {
    if (criteriaArray.length > 0)
      return criteriaArray[0]
    else
      null
  }
}


